module.exports = __webpack_public_path__ + "img/droplet.55255027.svg";